

import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  StyleSheet,
  View,
  SafeAreaView,
  Platform,
  useWindowDimensions,
  FlatList,
  ActivityIndicator,
} from "react-native";
import { Card, Checkbox } from "react-native-paper";
import { useTheme } from "@react-navigation/native";
import { createCommonStyles } from "../../../styles/commonStyles";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import CustomInput from "../../../components/CustomInput";
import CustomButton from "../../../components/CustomButton";
import CustomText from '../../../components/CustomText/CustomText';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomDropDown from "../../../components/CustomDropDown/CustomDropdown";
import { useTranslation } from "react-i18next";
import CustomCalendar from "../../../components/CustomCalendar/CustomCalendar";
import {
  changeDateFromDDMMYYYYtoYYYYMMDD,
  changeDateFromYYYYMMDDToDDMMYYYY,
  formatDateForUI,
} from "../../../constants/FormatDate";
import {
  useHRAdminEmployees,
} from "../../../hooks/useHRAdminEmployees";
import { useTableHelper } from "../../../hooks/useTableHelper";
import Swal from "sweetalert2";
import { showMessage } from "react-native-flash-message";
import * as ExpoDocumentPicker from "expo-document-picker";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
  renderers,
} from 'react-native-popup-menu';

const SpecialDocumentsListView = React.memo(
  ({
    item,
    index,
    handleEditPress,
    styles,
    emplSpecialDocHelper,
    t,
    handleDelete,
    resetDates
  }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [fieldName, setFieldName] = useState("")
    const [showCalendarDos, setShowCalendarDos] = useState(false);
    const [showCalendarDoa, setShowCalendarDoa] = useState(false);
    const [selectedData, setSelectedData] = useState({
      startDate: item.issueDate || "",
      endDate: item.expiryDate || ""
    });

    const dateHelper = useCallback(() => {
      let dateArr = [];
      let tmpTdate = "";
      let tmpFdate = "";
      if (
        selectedData?.startDate &&
        selectedData?.startDate.match(/^\d{4}-\d{2}-\d{2}$/)
      ) {
        tmpFdate = changeDateFromYYYYMMDDToDDMMYYYY(selectedData?.startDate);
      }
      if (
        selectedData?.endDate &&
        selectedData?.endDate.match(/^\d{4}-\d{2}-\d{2}$/)
      ) {
        tmpTdate = changeDateFromYYYYMMDDToDDMMYYYY(selectedData?.endDate);
      }
      dateArr.push(tmpFdate);
      dateArr.push(tmpTdate);
      return dateArr;
    }, [selectedData]);

    const getValidDateOrToday = (dateStr) => {
      if (dateStr === '') return ''; // Allow empty string to pass through
      if (!dateStr) return new Date().toISOString().split('T')[0];
      // Extract date part if datetime string is passed
      const dateOnly = dateStr.split('T')[0];
      // Regex to match YYYY-MM-DD
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (isoDateRegex.test(dateOnly)) {
        return dateOnly;
      }
      // fallback to today
      return new Date().toISOString().split('T')[0];
    };

    const onShowCalendarPressDos = () => {
      setFieldName('issueDate')
      const validDate = getValidDateOrToday(item.issueDate);
      setSelectedData({
        startDate: validDate,
        endDate: validDate,
      });
      setShowCalendarDos(!showCalendarDos);
      setShowCalendarDoa(false);
    };

    const onShowCalendarPressDoa = () => {
      setFieldName('expiryDate')
      const validDate = getValidDateOrToday(item.expiryDate);
      setSelectedData({
        startDate: validDate,
        endDate: validDate,
      });
      setShowCalendarDoa(!showCalendarDoa);
      setShowCalendarDos(false);
    };

    const handleDateChange = (newDates) => {
      const today = new Date().toISOString().split("T")[0];
      setSelectedData(newDates);
      if (fieldName === 'issueDate') {
        const safeIssue =
          !newDates?.startDate || newDates.startDate.trim() === "" ? '' : newDates.startDate;
        handleEditPress(index, item, 'issueDate', safeIssue);
      } else if (fieldName === 'expiryDate') {
        // if you're using range, prefer endDate; if single date, fall back to startDate
        const picked = newDates?.endDate && newDates.endDate.trim() !== ""
          ? newDates.endDate
          : (newDates?.startDate || '');
        handleEditPress(index, item, 'expiryDate', picked);
      }
      // optional: close whichever calendar was open
      setShowCalendarDos(false);
      setShowCalendarDoa(false);
    };

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };

    useEffect(() => {
      if (resetDates) {
        const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
        setSelectedData({
          startDate: item.issueDate || today,
        });
        const from = changeDateFromYYYYMMDDToDDMMYYYY(item.issueDate || today);
      }
    }, [resetDates, item.issueDate]);

    const CreateDivider = () => {
      return (
        <View
          style={{
            borderBottomColor: '#000000',
            borderBottomWidth: StyleSheet.hairlineWidth,
          }}
        />
      );
    };

    const removeAttachment = useCallback((index, item) => {
      handleEditPress(index, item, "fileName", '');
      handleEditPress(index, item, "fileType", '');
      handleEditPress(index, item, "fileData", null);
    }, [handleEditPress, index, item]);

    const showAttachment = (index, item) => {
      //* the attachment section to be shown/hidden
      return (
        <View>
          <View style={styles.attachmentContainer}>
            <View style={styles.attachmentIcons}>
              <Ionicons
                name="document-outline"
                style={styles.icons}
              />
            </View>
            <View style={styles.attachmentNameContainer}>
              <CustomText style={styles.attachmentNameText}>{item.fileName}</CustomText>
            </View>
            <View style={styles.attachmentIcons}>
              <Menu
                renderer={renderers.SlideInMenu}
                style={styles.attachmentMenu}
              >
                <MenuTrigger>
                  <Ionicons
                    name="ellipsis-vertical"
                    style={styles.dotsIcon}
                  />
                </MenuTrigger>
                <MenuOptions customStyles={optionsStyles}>
                  <MenuOption onSelect={() => openAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:open')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption onSelect={() => downloadAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:downloadDocument')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption onSelect={() => removeAttachment(index, item)} customStyles={removeOptionStyles} text={t('common:remove')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption customStyles={cancelOptionStyles} text={t('common:cancel')}>
                  </MenuOption>
                </MenuOptions>
              </Menu>
            </View>
          </View>
        </View>
      );
    };

    const downloadAttachment = useCallback(async (index, item) => {
      let downloadName = '';
      const fileName = item.fileName;
      const fileType = item.fileType?.toLowerCase();
      if (fileName?.toLowerCase().endsWith(`.${fileType}`)) {
        downloadName = fileName;
      } else {
        downloadName = `${fileName || item.name || 'file_' + index}.${fileType}`;
      };

      const mimeType = fileType ? `application/${fileType}` : 'application/octet-stream';

      // create blob
      const blobData = await fetch(`data:plain/text;base64,${item.fileData}`).then(res => {
        return res.blob();
      });
      // create download link
      const url = URL.createObjectURL(blobData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        downloadName
      );

      // insert link on page
      document.body.appendChild(link);

      // start download
      link.click();

      // remove link
      link.remove();

      URL.revokeObjectURL(url);
    }, []);

    const openAttachment = async (index, item) => {
      const newWindow = window.open('', '_blank');
      if (!newWindow) {
        alert('Popup blocked. Please allow popups for this site.');
        return;
      };
      let base64Data = item.fileData;
      let type = item.fileType.toLowerCase();
      let style = '';

      if (type === 'pdf') {
        type = 'application/pdf';
        style = 'width: 100%; height: 100%; display: block;';
      } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
        type = `image/${type}`;
        style = 'display: block; max-width: 100%; height: auto;';
      } else {
        // fallback MIME type
        type = 'application/octet-stream';
        style = 'display: block; max-width: 100%; height: auto;';
      }

      const uri = `data:${type};base64,${base64Data}`;

      newWindow.document.write(`
        <html>
          <head>
            <title>${item.fileName || item.name || 'file_' + index}</title>
            <style>
              embed { ${style} }
            </style>
          </head>
          <body style="margin:0">
            <embed src="${uri}" type="${type}" />
          </body>
        </html>
      `);
      newWindow.document.close();
    };

    const pickDocument = useCallback(async (index, item) => {
      //* select attachment
      // TODO: get size from oasis settings (DB)
      const maxSize = 30 * 1048576;
      let file = null;
      let uri = null;
      let type = null;
      let ext = null;

      try {
        // TODO: add types in constants file, and get them from there
        let result = await ExpoDocumentPicker.getDocumentAsync({
          type: [
            "image/jpeg",
            "image/gif",
            "image/png",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ],
          copyToCacheDirectory: false,
          multiple: false,
        });

        if (!result.canceled) {
          file = result.output[0];
          type = result.assets[0].mimeType;
          uri = result.assets[0].uri.split(";base64,")[1];
          name = file.name;
          ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
        } else {
          return;
        };

        // if size allowed
        if (file.size < maxSize) {
          handleEditPress(index, item, "fileName", name);
          handleEditPress(index, item, "fileType", ext);
          handleEditPress(index, item, "fileData", uri);
        } else {
          // file is too large
          showMessage({
            message: t('common:errFile'),
            type: "warning",
            duration: 3000,
          });
        };
      } catch (error) {
        console.error(error);
      };
    }, []);


    return (
      <View>
        <SafeAreaView>
          <SafeAreaView style={styles.row}>
            <View style={[styles.item]}>

              <SafeAreaView style={[styles.row]}>
                <View style={item.fileData ? styles.attachmentsExistView : styles.attachmentsNotExistView}>
                  {item.fileData ?
                    (showAttachment(index, item)) :
                    <CustomLabel type='AVAILABLEUSED' value={t('common:noAttachment')} />}
                </View>
                <Ionicons
                  name={"attach-outline"}
                  style={[styles.icons, { fontSize: 30 }]}
                  onPress={() => pickDocument(index, item)}
                />
              </SafeAreaView>
            </View>
            <View style={[styles.item]}>
              <CustomInput
                value={item.name}
                setValue={(text) => {
                  handleEditPress(index, item, "name", text);
                }}
                editable={true}
                maxLen={255}
                type="MAININPUT"
              />
            </View>
            {/* // TODO Commenting out some fields as are legacy fields and are now irelevant */}
            {/* <View style={[styles.item]}>
              <CustomLabel value={t("common:number")} type="SUBTITLE" />
              <CustomInput
                value={item.number}
                setValue={(text) => {
                  handleEditPress(index, item, "number", text);
                }}
                editable={true}
                maxLen={255}
                type="ARRAY"
              />
            </View> */}
            <View style={[styles.item]}>
              <CustomDropDown
                defValue={item.docStatusCode}
                options={emplSpecialDocHelper.DocStatusCode}
                value={item.docStatusCode}
                setValue={(e) =>
                  handleEditPress(index, item, "docStatusCode", e)
                }
                type="FULL"
              />
            </View>

            <View style={[styles.containerCalendar]}>
              <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
                <SafeAreaView>
                  <CustomInput
                    value={formatDateForUI(item.issueDate)}
                    setValue={() => { }}
                    maxLen={50}
                    editable={false}
                    type="MAININPUT"
                  />
                </SafeAreaView>
                <Ionicons
                  name={showCalendarDos ? "calendar" : "calendar-outline"}
                  style={styles.icons}
                  onPress={onShowCalendarPressDos}
                />
              </SafeAreaView>
            </View>
            <View style={[styles.containerCalendar]}>
              <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
                <SafeAreaView>

                  <CustomInput
                    value={formatDateForUI(item.expiryDate)}
                    setValue={() => { }}
                    maxLen={50}
                    editable={false}
                    type="MAININPUT"
                  />
                </SafeAreaView>
                <Ionicons
                  name={showCalendarDoa ? "calendar" : "calendar-outline"}
                  style={styles.icons}
                  onPress={onShowCalendarPressDoa}
                />
              </SafeAreaView>
            </View>
            <SafeAreaView style={[styles.containerCheck]}>
              <View style={[styles.itemCheck]}>
                <CustomLabel value={t('common:isRenewed')} type="AVAILABLEUSED_SECONDARY" />
                <Checkbox
                  status={item.isRenewed ? 'checked' : 'unchecked'}
                  onPress={() => handleEditPress(index, item, 'isRenewed', !item.isRenewed)}
                  color={item.isRenewed ? '#86BC25' : undefined}
                />
              </View>
              <View style={[styles.itemCheck]}>
                <CustomLabel value={t('common:notifyMe')} type="AVAILABLEUSED_SECONDARY" />
                <Checkbox
                  status={item.notifyMe ? 'checked' : 'unchecked'}
                  onPress={() => handleEditPress(index, item, 'notifyMe', !item.notifyMe)}
                  color={item.notifyMe ? '#86BC25' : undefined}
                />
              </View>
            </SafeAreaView>
            <SafeAreaView>
              <CustomButton
                iconName="trash-outline"
                onPress={() => handleDelete(item, index, 'ui')}
                show="HOME_BELL"
                type="HOME_BELL"
                textTop="2"
                sz={30}
              />
              {/* // TODO No toggle for now because we have less data  */}
              {/* <Ionicons
                name={
                  isExpanded
                    ? "chevron-down-outline"
                    : "chevron-forward-outline"
                }
                style={styles.icons}
                onPress={toggleExpand}
              /> */}
            </SafeAreaView>
          </SafeAreaView>
          {/* set to always open now with less data  */}
          {true && (
            <>
              {(showCalendarDos || showCalendarDoa) && (
                <SafeAreaView style={styles.calendarNoOverlay}>
                  <CustomCalendar
                    calendarType={"RangePicker"}
                    setRange={handleDateChange}
                    range={selectedData}
                    allowSingleDate={true}
                    startingYear={1950}
                  />
                </SafeAreaView>
              )}
              {/* // TODO Commenting out some fields as are legacy fields and are now irelevant */}
              {/* <SafeAreaView style={styles.row2}>
                <View style={[styles.item]}>
                  <CustomLabel value={t("common:issuedBy")} type="SUBTITLE" />
                  <CustomInput
                    value={item.issuedBy}
                    setValue={(text) => {
                      handleEditPress(index, item, "issuedBy", text);
                    }}
                    editable={true}
                    maxLen={255}
                    type="ARRAY"
                  />
                </View>
                <View style={[styles.item]}>
                  <CustomLabel value={t("common:relType")} type="SUBTITLE" />
                  <CustomDropDown
                    defValue={item.relType}
                    options={emplSpecialDocHelper.RelType}
                    value={item.relType}
                    setValue={(e) =>
                      handleEditPress(index, item, "relType", e)
                    }
                    type="ARRAYDROPDOWN"
                  />
                </View>
                <View style={[styles.item]}>
                  <CustomLabel value={t("common:profession")} type="SUBTITLE" />
                  <CustomInput
                    value={item.profession || ''}
                    setValue={(text) => {
                      handleEditPress(index, item, "profession", text);
                    }}
                    editable={true}
                    maxLen={100}
                    type="ARRAY"
                  />
                </View>
                <View style={[styles.item]}>
                  <CustomLabel value={t("common:professionOthLang")} type="SUBTITLE" />
                  <CustomInput
                    value={item.professionOtherLa || ''}
                    setValue={(text) => {
                      handleEditPress(index, item, "professionOtherLa", text);
                    }}
                    editable={true}
                    maxLen={100}
                    type="ARRAY"
                  />
                </View>
              </SafeAreaView> */}
              <SafeAreaView style={styles.row2}>
                <View style={[styles.item]}>
                  <CustomLabel value={t("common:Comments")} type="SUBTITLE" />
                  <CustomInput
                    value={item.comments || ''}
                    setValue={(e) => handleEditPress(index, item, 'comments', e)}
                    editable={true}
                    maxLen={255}
                    multiline={true}
                    numberOfLines={4}
                    type="MAININPUT"
                  />
                </View>
              </SafeAreaView>
            </>
          )}
        </SafeAreaView>
      </View >
    );
  }
);

const HRAdminEmplSpecialDocuments = (props) => {
  const { width } = useWindowDimensions();
  const { colors } = useTheme();
  const common = createCommonStyles(colors);
  const styles = makeStyles(colors, width);
  const [changes, setChanges] = useState({});
  const [deletedItems, setDeletedItems] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  // * Will not investigate duplicates for this due to time. Re-enable and check salary schemes to see how to implement. 
  // const [duplicates, setDuplicates] = useState([]);
  const [emplSpecialDocHelper, setEmplSpecialDocHelper] = useState({});
  const [specialDocs, setSpecialDocs] = useState([]);
  const { t } = useTranslation();
  const ref = useRef(null);
  const { GetSpecialDocHelper, GetSpecialDocuments, SaveSpecialDocuments, DeleteSpecialDocuments, isLoading } = useHRAdminEmployees();
  const { rowAdd, rowEdit, rowDelete } = useTableHelper();
  const [resetDates, setResetDates] = useState([false]);

  const showWarningPopup = async () => {
    return Swal.fire({
      title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t(
        "common:changeSchemeMessage"
      )}</text>`,
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t(
        "common:cancel"
      )}</text>`,
      cancelButtonColor: "#d3d3d3",
      confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t(
        "common:confirmMessage"
      )}</text>`,
      confirmButtonColor: "#A0A2FF",
    });
  };

  useEffect(() => {
    loadData();
  }, [props.selectedEmployee, props.selectedCompany]);

  const loadData = () => {
    GetSpecialDocHelper().then((resp) => {
      setEmplSpecialDocHelper(resp);
      GetSpecialDocuments(props.selectedEmployee.employeeID).then((resp) => {
        setSpecialDocs(resp);
        setOriginalData(resp);
      }).catch((error) => console.error(error))
    }).catch((error) => console.error(error))
  }

  const handleEditPress = useCallback(
    async (index, item, key, value) => {
      // Check if the value has changed
      if (item[key] === value) return;
      // Store the original value for potential rollback
      // Use rowEdit to apply the change
      rowEdit(
        index,
        item,
        key,
        value,
        changes,
        setChanges,
        specialDocs,
        setSpecialDocs
      );
    },
    [showWarningPopup, rowEdit, changes, specialDocs]
  );

  const handleCancelChanges = () => {
    const rolledBackDocs = originalData.map((obj) => ({ ...obj }));
    setSpecialDocs(rolledBackDocs);
    setDeletedItems([]);
    setChanges({});
    showMessage({
      message: t("common:changesCancelled"),
      type: "info",
      duration: 3000,
    });
    setResetDates(true);
  };

  // * Validator 
  // TODO Can be abstracted as well probably -- But column names matter ? 
  const validateInput = () => {
    let ret = [true, t('common:validationSuccess')]
    specialDocs.forEach((itr) => {
      // * Check empty description
      if (itr.docStatusCode === '')
        ret = [false, t('common:docStatusEmpty')]
      // else if (itr.issuedBy === '')
      //   ret = [false, t('common:issuedByEmpty')]
    })
    return (ret)
  }

  useEffect(() => {
    // Check if there is exactly one empty entry left
    // Filter out deleted lines first
    const filteredEntries = Object.entries(changes).filter(([key, value]) => {
      return !deletedItems.includes(value.ui);
    });
    if (
      filteredEntries.length === 1 &&
      typeof filteredEntries[0][1] === 'object' &&
      filteredEntries[0][1] !== null &&
      Object.keys(filteredEntries[0][1]).length === 0
    ) {
      const rolledBackDocs = originalData.map((obj) => ({ ...obj }));
      setSpecialDocs(rolledBackDocs);
      setDeletedItems([]);
      setChanges({});
      setResetDates(true);
    }
  }, [changes])

  const handleSave = async () => {
    try {
      if (Object.entries(changes).length == 0 && deletedItems.length == 0) {
        showMessage({
          message: t('common:noChanges'),
          type: "danger",
          duration: 3000,
        })
        return;
      }

      let valRet = validateInput();
      if (!valRet[0]) {
        showMessage({
          message: valRet[1],
          type: "danger",
          duration: 3000,
        })
        return;
      }
      // convert empty issueDate/expiryDate strings to null (to be parsed correctly by API)
      function convertEmptyDatesToNull(specialDocs) {
        return specialDocs.map(doc => ({
          ...doc,
          issueDate: (doc.issueDate === "" || doc.issueDate == 0) ? null : doc.issueDate,
          expiryDate: (doc.expiryDate === "" || doc.expiryDate == 0) ? null : doc.expiryDate,
        }));
      }
      const updatedSpecialDocs = convertEmptyDatesToNull(specialDocs);
      let savePromises = [];
      let updateSucc = true;
      let deleteSucc = true;

      savePromises.push(
        SaveSpecialDocuments(
          updatedSpecialDocs,
          props?.selectedEmployee?.employeeID
        ).then((resp) => {
          updateSucc = resp;
        }).catch((error) => {
          console.error("Save error", error);
          updateSucc = false;
        })
      );
      if (deletedItems.length > 0) {
        savePromises.push(DeleteSpecialDocuments(deletedItems)
          .then((res) => {
            deleteSucc = res;
          }).catch((error) => {
            console.error('delete failed', error);
            deleteSucc = false;
          }))
      };
      // Wait for all promises to resolve
      await Promise.all(savePromises);
      // === Handle results ===
      if (!updateSucc || !deleteSucc) {
        showMessage({
          message: t("common:errorSave"),
          type: "danger",
          duration: 3000,
        });
        return;
      }
      // * Reload after save
      loadData();
      removeFromChangesAfterSave();
      setResetDates(true);
      // === Success message ===
      showMessage({
        message: t("common:changesSavedSuccessfully"),
        type: "success",
        duration: 3000,
      });

    } catch (error) {
      console.error("Save error", error);
      showMessage({
        message: t("common:errorSave"),
        type: "danger",
        duration: 3000,
      });
    }
  };

  const handleDelete = (item, index, attribute) => {
    rowDelete(item, index, attribute, changes, setChanges, specialDocs, setSpecialDocs, setDeletedItems, ref)
  }

  const removeFromChangesAfterSave = () => {
    setDeletedItems([]);
    setChanges({});
  };

  const renderSpecialDocuments = useCallback(
    ({ item, index }) => (
      <Card style={[common.cardstyle]}>
        <Card.Content>
          <SpecialDocumentsListView
            item={item}
            index={index}
            handleEditPress={handleEditPress}
            emplSpecialDocHelper={emplSpecialDocHelper}
            styles={styles}
            t={t}
            handleDelete={handleDelete}
            resetDates={resetDates}
          />
        </Card.Content>
      </Card>
    ),
    [
      specialDocs,
      handleEditPress,
      handleDelete,
      styles,
    ]
  );

  if (isLoading) {
    return (
      <View style={styles.loader}>
        <ActivityIndicator animating={true} color={colors.blue} />
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.mainView}>
      <View style={styles.container}>
        <View style={[styles.buttons, styles.functionalityButtons]}>
          <CustomButton
            text={t("common:new")}
            onPress={() => {
              rowAdd(
                specialDocs,
                setSpecialDocs,
                ['ui', 'employeeId'],
                ['isRenewed', 'notifyMe'],
                ref,
                t,
                ['employeeId'],
                [],
                changes,
                setChanges,
                undefined,
                undefined,
                "ui",
                false,
                ['issueDate', 'expiryDate']
              );
            }}
            type="BUTTON_ADD"
            textTop="0"
            sz={15}
          />
          {(Object.keys(changes).length > 0 ||
            changes.length > 0 || deletedItems.length > 0) && (
              <CustomButton
                text={t("common:saveFunction")}
                onPress={handleSave}
                type="BUTTON_SAVE"
                isGradient={true}
                textTop="0"
                sz={15}
              />
            )}
          <CustomButton
            text={t("common:cancel")}
            onPress={handleCancelChanges}
            type="BUTTON_CANCEL"
            textTop="0"
            sz={15}
          />
        </View>
        <FlatList
          data={specialDocs}
          keyExtractor={(item, index) => `${item.ui}-${index}`}
          renderItem={renderSpecialDocuments} // Use the memoized function here
          refreshing={isLoading}
          ref={ref}
          ListHeaderComponent={
            <SafeAreaView style={common.listTitle}>
              <SafeAreaView style={styles.row}>
                <CustomLabel value={t("common:doc")} type="SUBTITLE" />
                <CustomLabel value={t("common:name")} type="SUBTITLE" />
                <CustomLabel value={t("common:docStatus")} type="SUBTITLE" />
                <CustomLabel value={t("common:issueDate")} type="SUBTITLE" />
                <CustomLabel value={t("common:expiryDate")} type="SUBTITLE" />
                <SafeAreaView style={[{ marginRight: '15%' }]} />
              </SafeAreaView>
              <SafeAreaView style={common.divider} />
            </SafeAreaView>
          }
          ListEmptyComponent={
            isLoading ? (
              <ActivityIndicator animating={true} color={colors.blue} />
            ) : (
              // will not be shown because API returns empty row
              // TODO: remove, and make isLoading work correctly
              <CustomLabel
                value={t("common:noSpecialDocsDataPreview")}
                type="NO_FUNCTIONS"
              />
            )
          }
          initialNumToRender={4}
        />
      </View>
    </SafeAreaView>
  );
};

const makeStyles = (colors, width) =>
  StyleSheet.create({
    mainView: {
      flex: 1,
    },
    rowView: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "center",
    },
    container: {
      flex: 1,
    },
    cardStyleBranch: {
      margin: 5,
      marginHorizontal: 10,
      borderRadius: 5,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      backgroundColor: colors.background_card,
    },
    calendarNoOverlay: {
      flex: 1,
      minHeight: 295,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
    },
    calendarOverlay: {
      position: 'absolute',
      top: 10,
      height: 295,
      backgroundColor: 'white',
      borderRadius: 10,
      zIndex: 99999,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.5,
      shadowRadius: 20,
      elevation: 15,
    },
    row: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    row2: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      margin: 30
    },
    row3: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      margin: 20
    },
    dropdownView: {
      width: '80%',
      flex: 1,
      marginBottom: 5,
    },
    item: {
      flex: 1,
      justifyContent: "center",
      marginRight: 6
    },
    containerCalendar: {
      justifyContent: "center",
      marginRight: 6,
      alignSelf: "center",
      alignItems: "center"
    },
    item2: {
      flex: 1,
      justifyContent: "center",
      marginRight: 6,
      alignSelf: "center",
      alignItems: "center"
    },
    containerCheck: {
      marginHorizontal: 5,
      alignItems: 'flex-end'
    },
    itemCheck: {
      flexDirection: 'row',
    },
    itemCalendarRow: {
      flexDirection: 'row',
    },
    itemCalendar: {
      alignContent: 'center',
      justifyContent: 'center',
    },
    buttons: {
      flexDirection: "row",
      justifyContent: "flex-end",
      alignSelf: "flex-end",
      marginRight: 15,
    },
    functionalityButtons: {
      justifyContent: "flex-end",
    },
    loader: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "4%",
    },
    icons: {
      fontSize: 24,
      marginHorizontal: 10,
    },
    attachmentContainer: {
      flexDirection: 'row',
      borderRadius: 10,
      marginHorizontal: '3%',
      marginVertical: '1%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    attachmentsNotExistView: {
      flex: 1,
      borderColor: colors.border_card,
      borderWidth: 2,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      shadowColor: colors.card_line,
      backgroundColor: colors.background_card,
      borderRadius: 10,
      padding: 5,
      margin: 10,
    },
    attachmentIcons: {
      width: 20,
      alignSelf: 'center',
      color: colors.text_primary,
    },
    attachmentNameContainer: {
      flex: 7,
      alignItems: 'flex-start',
      paddingHorizontal: 12,
    },
    attachmentNameText: {
      fontSize: 16,
      color: colors.text_primary,
      alignSelf: 'center',
    },
    dotsIcon: {
      fontSize: 21,
      color: colors.text_primary
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 99998,
    },
    attachmentsExistView: {
      flex: 1,
      borderColor: colors.border_card,
      borderWidth: 2,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      shadowColor: colors.card_line,
      backgroundColor: colors.background_card,
      borderRadius: 10,
      padding: 5,
      margin: 10,
    },
  });
const optionsStyles = {
  optionsContainer: {
    marginHorizontal: '3.5%',
    marginVertical: '-3%',
    borderRadius: 10,
  },
  optionWrapper: {
    height: 50,
    justifyContent: 'center',
  },
};
const removeOptionStyles = {
  optionText: {
    textAlign: 'center',
    fontSize: 16,
    color: '#dd3636',
  },
};
const cancelOptionStyles = {
  optionText: {
    textAlign: 'center',
    fontSize: 16,
  },
};

export default HRAdminEmplSpecialDocuments;